import { useNavigate } from 'react-router';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { RequestEvaluationDto } from '../../../commonTypes/user.types';

const useHttpRequestEvaluation = () => {
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();
    const { t } = useTranslation('evaluations');

    const exec = (body: RequestEvaluationDto) => {
        const { exec, abort } = userApi.requestEvaluation({
            body,
            onSuccess: () => {
                toastHandler.push('success', t('requestEvaluationTitle'), t('requestEvaluationSucceded'));
                navigate(`/evaluation`);
            },
            onError: error => {
                if (error.includes('"evaluateeUserSubs" does not contain 1 required value(s)')) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationEvaluateeMissing'));
                } else if (error.includes('"dueDate" is not allowed to be empty')) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationDueDateMissing'));
                } else if (error.includes('"evaluatorToEvaluateeRoleId" is not allowed to be empty')) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationEvaluatorRoleMissing'));
                } else if (error.includes('"topicIds" does not contain 1 required value(s)')) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationTopicMissing'));
                } else if (error.includes('"evaluatorUserSub" is not allowed to be empty')) {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationEvaluatorMissing'));
                } else {
                    toastHandler.push('error', t('requestEvaluationTitle'), t('requestEvaluationFailed'));
                }
            },
        });
        exec();
        return abort;
    };
    return { exec };
};

export default useHttpRequestEvaluation;
